export { default } from "./MailingListsPage";



// WEBPACK FOOTER //
// ./src/screens/MailingLists/index.ts